<template>
  <div>
    <div v-if="isAdmin || isSectorManager" class="is-border-top is-border-left is-border-right">
      <div class="tabs is-marginless-bottom  has-bg-white">
        <ul class="has-text-weight-medium is-borderless">
          <li :class="{'is-active':panel === 'DOC_ADV'}">
            <a @click="changePanel('DOC_ADV')"
              :class="{'has-bg-light':panel === 'DOC_ADV'}"
            >Documents ADV</a>
          </li>
          <li class="is-border-left" :class="{'is-active':panel === 'DOC_SELLER'}">
            <a @click="changePanel('DOC_SELLER')"
               :class="{'has-bg-light':panel === 'DOC_SELLER'}"
            >
              <div v-if="adv && adv.seller_documents && adv.seller_documents.length > 0"
                   :data-badge="adv.seller_documents.length"
                   class="badge has-badge-rounded has-badge-medium has-badge-notification is-padding-right-small">
                Documents déposés par vendeur
              </div>
              <span v-else>Documents déposés par vendeur</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="is-border-top">
      <div class="columns is-align-items-flex-start">
        <div v-show="panel === 'DOC_ADV'" class="column is-6 is-paddingless is-border-left">
          <div class="has-bg-white is-border-right">
            <div class="row-width-actions-bar columns is-gapless is-vcentered">
              <div class="column is-padding-left"> <!-- has-text-dark -->
                <span class="has-text-dark title is-6">Suivi de vente ({{(contractLength + loansLength + accuseLength + signatureLength + notaireLength)|pluralize}})</span>
              </div>
              <div class="column is-narrow is-border-left">
                <button class="page-header-btn is-small is-square"
                        @click="toggleTable('sales_follow')"
                >
                  <span class="icon is-size-4 has-text-dark">
                    <i class="fal " :class="open.sales_follow ? 'fa-times' :'fa-chevron-down'"></i></span>
                </button>
              </div>
            </div>
            <div class="column is-12 is-border-top" v-if="displaySalesFollowList" v-show="open.sales_follow === true">
              <div class="field" v-if="contrat && contrat.documents && contrat.documents.length">
                <view-file-list :documents="contractDocuments" :isArray="true"
                                :can-drag="false" :can-edit="(isAdmin || isSectorManager)" :can-edit-display="isAdmin || isSectorManager"
                                @update="saveDocuments"></view-file-list>
              </div>
              <div class="field" v-if="contrat && contrat.accuse_de_reception && contrat.accuse_de_reception">
                <view-file-list :documents="[contrat.accuse_de_reception]"
                                :can-drag="false" :can-edit="isAdmin || isSectorManager" :can-edit-display="isAdmin || isSectorManager"
                                @update="saveDocuments"></view-file-list>
              </div>
              <div class="field" v-if="loansDocuments && financement.loans && financement.loans.length">
                <view-file-list :documents="loansDocuments" :isArray="true"
                                :can-drag="false" :can-edit="isAdmin || isSectorManager" :can-edit-display="isAdmin || isSectorManager"
                                @update="saveDocuments"></view-file-list>
              </div>
              <div class="field" v-if="notaire && notaire.documents && notaire.documents.length">
                <view-file-list :documents="notaireDocuments" :isArray="true"
                                :can-drag="false" :can-edit="isAdmin || isSectorManager" :can-edit-display="isAdmin || isSectorManager"
                                @update="saveDocuments"></view-file-list>
              </div>
              <div class="field"
                   v-if="signature && signature.contrat && signature.contrat.path && signature.contrat.cloudinary_id">
                <view-file-list :documents="signatureDocuments" :isArray="true"
                                :can-drag="false" :can-edit="isAdmin || isSectorManager" :can-edit-display="isAdmin || isSectorManager"
                                @update="saveDocuments"></view-file-list>
              </div>
            </div>
          </div>
          <div v-if="(choixDocuments || tmaDocuments) && choixEtTmaLength"
               class="has-bg-white is-border-right is-border-top">
            <div class="row-width-actions-bar columns is-gapless is-vcentered ">
              <div class="column is-padding-left"> <!-- has-text-dark -->
                <span class="has-text-dark title is-6">Choix et TMA ({{choixEtTmaLength|pluralize}})</span>
              </div>
              <div class="column is-narrow is-border-left">
                <button class="page-header-btn is-small is-square"
                        @click="toggleTable('tma')"
                >
                  <span class="icon is-size-4 has-text-dark">
                    <i class="fal " :class="open.tma ? 'fa-times' :'fa-chevron-down'"></i></span>
                </button>
              </div>
            </div>
            <div class="column is-12 is-border-top" v-if="(choixDocuments || tmaDocuments) && choixEtTmaLength"
                 v-show="open.tma === true">
              <div class="field">
                <view-file-list :documents="choixDocuments" :is-array="true"
                                :can-drag="false" :can-edit="isAdmin || isSectorManager" :can-edit-display="isAdmin || isSectorManager"
                                @update="saveDocuments"></view-file-list>
                <view-file-list :documents="tmaDocuments" :isArray="true"
                                :can-drag="false" :can-edit="isAdmin || isSectorManager" :can-edit-display="isAdmin || isSectorManager"
                                @update="saveDocuments"></view-file-list>
              </div>
            </div>
          </div>
          <div v-if="adv.documents" class="has-bg-white is-border-right is-border-top">
            <div class="row-width-actions-bar columns is-gapless is-vcentered">
              <div class="column is-padding-left"> <!-- has-text-dark -->
                <span class="has-text-dark title is-6">Documents Divers ({{isAdmin || isSectorManager ? advDocumentsLength + advMandatDeGestionLength : advDocumentsLength + advSellerDocumentsLength + advMandatDeGestionLength | pluralize}})</span>
              </div>
              <div class="column is-narrow is-border-left">
                <button class="page-header-btn is-small is-square"
                        @click="toggleTable('other')"
                >
                  <span class="icon is-size-4 has-text-dark">
                    <i class="fal " :class="open.other ? 'fa-times' :'fa-chevron-down'"></i></span>
                </button>
              </div>
            </div>
            <div class="column is-12 is-border-top"
                 v-if="advDocumentsLength || advSellerDocumentsLength ||advMandatDeGestionLength "
                 v-show="open.other === true">
              <div class="field" v-if="adv.documents && advDocumentsLength">
                <view-file-list :documents="adv.documents" :is-array="true"
                                :can-drag="false" :can-edit="isAdmin || isSectorManager" :can-edit-display="isAdmin || isSectorManager"
                                @update="val => updateDocument(val, 'documents')"></view-file-list>
              </div>
              <div class="field" v-if="!(isAdmin || isSectorManager) && adv.seller_documents && advSellerDocumentsLength"
              >
                <view-file-list :documents="adv.seller_documents" :is-array="true"
                                :can-drag="false" :can-edit="true" :can-edit-display="false"
                                @update="val => updateDocument(val, 'seller_documents')"></view-file-list>
              </div>
              <!-- <div class="field" v-if="adv.mandat_de_gestion_file && advMandatDocumentsLength">
                <view-file-list :documentsObject="adv.mandat_de_gestion_file"
                                :can-drag="false" :can-edit="isAdmin" :can-edit-display="isAdmin"
                                @update="val => updateDocument(val, 'mandat_de_gestion_file')"></view-file-list>
              </div> -->
              <div class="field" v-if="adv.mandat_de_gestion_file && advMandatDeGestionLength">
                <view-file-list :documentsObject="adv.mandat_de_gestion_file"
                                :can-drag="false" :can-edit="isAdmin || isSectorManager" :can-edit-display="isAdmin || isSectorManager"
                                @update="val => updateDocument(val, 'mandat_de_gestion_file')"></view-file-list>
              </div>
            </div>
          </div>
        </div>
        <div v-show="panel === 'DOC_SELLER' && (isAdmin || isSectorManager)" class="column is-6 is-paddingless is-border-left">
          <div class="has-bg-white is-border-right">
            <div class="columns is-gapless  is-vcentered is-border-bottom has-bg-light">
              <div class="column is-size-6">
                <div class="tabs is-minimalist is-small is-marginless-bottom is-padding">
                  <span><b>Documents déposés par vendeur</b> <span v-if="advSellerDocumentsLength">({{advSellerDocumentsLength|pluralize}})</span></span>
                </div>
              </div>
              <div class="column is-narrow is-border-left is-padding-xsmall" v-if="advSellerDocumentsLength">
                <a class="button is-ghost is-square has-text-grey" @click="toggleTable('seller')">
                  <span class="icon is-medium is-size-4"><i class="fal fa-ellipsis-h-alt"></i></span>
                </a>
              </div>
            </div>
            <div class="column is-12" v-if="advSellerDocumentsLength" v-show="open.seller === true">
              <div class="field">
                <view-file-list :documents="adv.seller_documents"
                                :can-drag="false" :can-edit="true" :is-array="true"
                                @update="val => updateDocument(val, 'seller_documents')"></view-file-list>
              </div>
            </div>
          </div>
        </div>
        <div v-show="panel === 'DOC_ADV'" class="column is-6 is-paddingless">
          <div class="notification is-warning has-text-centered is-marginless">
            <p class="is-uppercase is-size-7">
              <span class="icon"><i class="fas fa-exclamation-circle"></i></span>
              Seuls les fichiers au formats images sont autorisés (ex : .pdf, .jpeg, .png ...)
            </p>
          </div>
          <div class="field">
            <upload-file @upload="uploadDocument" :placeholder="'Sélectionnez ou déposez documents'"
                         :documents="isAdmin || isSectorManager ? adv.documents : adv.seller_documents" :show-list="false"
                         :is-large="true"></upload-file>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { AdvMx } from '../../mixins'
  import TableFileRow from './TableFileRow'
  import { mapGetters } from 'vuex'

  export default {
    name: 'Documents',
    data () {
      return {
        open: {
          seller: false,
          tma: false,
          other: false,
          sales_follow: false
        },
        panel: 'DOC_ADV'
      }
    },
    components: { TableFileRow },
    mixins: [AdvMx],
    computed: {
      ...mapGetters(['isAdmin', 'isSectorManager', 'isPromoteurMode']),
      contractLength () {
        return this.contractDocuments.length
      },
      accuseLength () {
        return this.accuseDocuments.length
      },
      loansLength () {
        return this.loansDocuments.length
      },
      notaireLength () {
        return this.notaireDocuments.length
      },
      signatureLength () {
        return this.signatureDocuments.length
      },
      choixEtTmaLength () {
        // if (this.isPromoteurMode) {
        return this.choixDocuments.length + this.tmaDocuments.length
        // } else return 0
      },
      advDocumentsLength () {
        return this.advDocuments.length
      },
      advMandatDeGestionLength () {
        if (this.advMandatDeGestion && this.advMandatDeGestion.path) {
          return 1
        } else {
          return this.advMandatDeGestion.length
        }
      },
      advSellerDocumentsLength () {
        return this.advSellerDocuments.length
      },
      displaySalesFollowList () {
        return this.contractLength || this.accuseLength || this.loansLength || this.notaireLength || this.signatureLength
      }
    },
    filters: {
      pluralize (v) {
        if (v > 1) return `${v} documents`
        else return `${v} document`
      }
    },
    methods: {
      deleteAdvMandat () {
        let adv = this.adv
        this.$set(adv, 'mandat_de_gestion_file', null)
        this.updateDocument(adv)
      },
      toggleTable (v) {
        this.$set(this.open, [v], !this.open[v])
      },
      updateDocument (data, key) {
        let adv = this.adv
        this.$set(adv, key, data)
        this.saveAdv(adv)
      },
      uploadDocument (data) {
        if (this.panel === 'DOC_ADV' && (this.isAdmin || this.isSectorManager)) {
          let newDocs = this.adv.documents.concat(data)
          this.$set(this.adv, 'documents', newDocs)
        } else {
          let newDocs = this.adv.seller_documents.concat(data)
          this.$set(this.adv, 'seller_documents', newDocs)
        }
        this.saveAdv(this.adv)
        this.$notify({
          type: 'is-success',
          text: 'Le document à été téléchargé avec succès'
        })
      },
      saveDocuments () {
        this.saveAdv(this.adv)
      },
      changePanel (panel) {
        if (this.panel !== panel) {
          this.panel = panel
          if (panel === 'DOC_SELLER' && this.open.seller !== true) {
            this.toggleTable('seller')
          } else if (panel === 'DOC_ADV' && this.open.sales_follow !== true) {
            this.toggleTable('sales_follow')
          }
        }
      }
    },
    created () {
      if (this.displaySalesFollowList) {
        this.toggleTable('sales_follow')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/adv/Documents.vue